<template>
    <brick-square-base>
        <div class="brick-icon">
            <i :class="icon"/>
        </div>
        <div class="brick-title">
            {{displayName}}
        </div>
    </brick-square-base>
</template>

<script>
    import BrickSquareBase from "@modules/JourneyBuilder/Components/Patterns/BrickSquareBase.vue";
    
    export default {
        name: 'menu-composable-square-brick',
        components: {
            BrickSquareBase
        },
        props: {
            displayName: {
                type: String,
                required: true
            },
            icon: {
                type: String,
                required: true
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "~@modules/JourneyBuilder/Style/composable-square-brick.scss";
</style>
